import { render, staticRenderFns } from "./PlbscfTable.vue?vue&type=template&id=5b519640&scoped=true&"
import script from "./PlbscfTable.ts?vue&type=script&lang=ts&"
export * from "./PlbscfTable.ts?vue&type=script&lang=ts&"
import style0 from "./PlbscfTable.css?vue&type=style&index=0&id=5b519640&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b519640",
  null
  
)

export default component.exports